import React, { useState } from 'react';

interface GenderSelectionProps {
  currentGender: 'M' | 'W' | 'N' | '';
  onChange: (gender: 'M' | 'W') => void;
  disabled?: boolean;
}

const GenderSelection: React.FC<GenderSelectionProps> = ({
  currentGender,
  onChange,
  disabled,
}) => {
  const [selectedGender, setSelectedGender] = useState<'M' | 'N' | 'W' | ''>(
    currentGender,
  );

  const handleGenderClick = (gender: 'M' | 'W') => {
    if (disabled) return;
    setSelectedGender(gender);
    onChange(gender);
  };

  return (
    <div
      className={`flex text-xs justify-center gap-0.5 border p-0.5 w-[104px] rounded-full items-center ${!selectedGender && 'hover:border-gray-400 hover:shadow-sm'} ${selectedGender === 'M' && 'border-blue-300'}  ${selectedGender === 'W' && 'border-pink-300'}`}
    >
      <div
        onClick={() => handleGenderClick('M')}
        className={` ${selectedGender === 'M' ? 'bg-blue-100 text-blue-500 px-2' : 'text-gray-400 bg-gray-100'} flex items-center justify-center cursor-pointer flex-1 text-center h-5 rounded-l-full`}
      >
        {selectedGender === 'M' ? 'Männlich' : 'M'}
      </div>
      <div
        className={`${selectedGender === 'W' ? 'bg-pink-100 text-pink-500 px-2' : 'text-gray-400 bg-gray-100'} flex items-center justify-center cursor-pointer flex-1 text-center h-5 rounded-r-full`}
        onClick={() => handleGenderClick('W')}
      >
        {selectedGender === 'W' ? 'Weiblich' : 'W'}
      </div>
    </div>
  );
};

export default GenderSelection;
